import { onLCP, onFCP, onTTFB, onFID, onCLS, onINP, } from 'web-vitals/attribution';
/**
 * Measure and report the web vital metrics of a web page
 * @example
 * ```tsx
 * import { WebVitals } from '@catawiki/runtime-toolkit';
 *
 * function sendToGoogleAnalytics({name, delta, value, id, attribution }) {
 *    gtag('event', name, {
 *    metric_id: id,
 *    metric_value: value,
 *    metric_delta: delta,
 *    metric_rating: 'good' | 'needs-improvement' | 'poor',
 *    metric_attribution: attribution
 *  });
 * }
 *
 * WebVitals.reportWebVitals(sendToGoogleAnalytics);
 *
 * @param onPerfEntry function that accepts an metric object and handles reporting to an analytics service
 */
export const reportWebVitals = (onPerfEntry) => {
    onCLS(onPerfEntry);
    onFID(onPerfEntry);
    onLCP(onPerfEntry);
    onFCP(onPerfEntry);
    onTTFB(onPerfEntry);
    onINP(onPerfEntry);
};
